<template>
  <div :style="SHOW_OTP_MODAL ? { pointerEvents: 'none' } : {}">
    <div class="col-12 pl-3 pr-3 pb-5">
      <!-- Appointment Details-->
      <card class="mt-5">
        <h4 slot="header" class="card-title">
          {{ $t("message.Appointment Details") }}
        </h4>
        <div slot="header" class="pb-5">
          <div class="row mt-4">
            <div class="pl-3 pr-2">
              <i class="fa fa-calendar-check" style="font-size: 1.3em; color: var(--color-primary)"></i>
            </div>
            <div class="col-10 col-lg-11">{{ appointmentDate }}</div>
          </div>

          <div class="row mt-2">
            <div class="pl-3 pr-2">
              <i class="fa fa-clock" style="font-size: 1.3em; color: var(--color-primary)"></i>
            </div>
            <div class="col-10 col-lg-11">{{ appointmentTime }}</div>
          </div>

          <div class="row mt-2">
            <div class="pl-3 pr-2">
              <i class="fa fa-user-md" style="font-size: 1.3em; color: var(--color-primary)"></i>
            </div>
            <div class="col-10 col-lg-11">
              {{ $t("message.Dr") }} . {{ doctor.firstName }}
              {{ doctor.lastName }}
              <br />
              <span style="font-size: smaller">{{
                doctor.specialityText
              }}</span>
            </div>
          </div>

          <div class="row mt-2" v-if="selectedLocation && selectedLocation.name">
            <div class="pl-3 pr-2">
              <i class="fas fa-hospital" style="font-size: 1.3em; color: var(--color-primary)"></i>
            </div>
            <div class="col-10 col-lg-11">
              <span>{{selectedLocation.name }}</span> <span v-if="selectedLocation.addressDetails && selectedLocation.addressDetails.address">{{' - ' + selectedLocation.addressDetails.address}}</span>
            </div>
          </div>
        </div>
      </card>

      <!-- Contact Details-->
      <!--    <card>
        <h4 slot="header" class="card-title">
          {{ $t("message.Contact Details") }}
        </h4>

        <div class="row mt-3">
          <div class="col-lg-6 pb-3">
            <VuePhoneNumberInput v-model="selectedMobileNumber" :border-radius="borderRadius" :default-country-code="defaultCountry" :disabled="OTP_VALIDATED" :preferred-countries="preferredCountries" @update="mobileNumberUpdate" />
            <div class="text-danger invalid-feedback mt-2" style="display: block" v-if="selectedMobileNumber && !isValidMobile">
              {{ $t("message.Please enter valid mobile number") }}
            </div>
            <fg-input class="hide-input" name="mobileNumber" v-model="selectedMobileNumber" v-validate="modelValidations.mobileNumber" :error="getError('mobileNumber')"></fg-input>
          </div>

          <div class="col-lg-6">
            <fg-input class="form-control-lg" :disabled="OTP_VALIDATED" name="email" :placeholder="$t('message.Email')" v-model="patient.email" v-validate="modelValidations.email" :error="getError('email')" addon-left-icon="now-ui-icons ui-1_email-85">
            </fg-input>
          </div>
        </div>

        <div class="row mt-5" v-if="!OTP_VALIDATED">
          <div class="col-12 text-center">
            <n-button type="primary" round @click.native="getOtp()">
              <h6 class="m-0">{{ $t("message.Get OTP") }}</h6>
            </n-button>
          </div>
        </div>
      </card> -->

      <!-- Patient list associated with the mobile number -->
      <card id="patient-list-section" v-if="!patient.firstName && !IS_NEW_PATIENT">
        <div slot="header">
          <h4 class="card-title mb-0">{{ $t("message.Associated Patients") }}</h4>
          <small>
            <i>{{ $t("message.Select from the list or create new patient") }}</i>
          </small>
        </div>

        <card v-for="patient in associatedPatients" :key="patient._id" @click.native="selectPatient(patient)">
          <div class="row">
            <div class="col-1">
              <i class="fa fa-user"></i>
            </div>
            <div class="col-10">
              <h6>{{ patient.firstName }} {{ patient.lastName }}</h6>
            </div>
            <div class="col-3 offset-1">{{ patient.gender }}</div>
            <div class="col-8">{{ getAge(patient.dob) }}</div>
          </div>
        </card>
        <div class="col-12 text-center">
          <h6>{{ $t("message.OR") }}</h6>
        </div>
        <div class="col-12 text-center">
          <n-button type="primary" round @click.native="createNewAccount()">
            <h6 class="m-0">{{ $t("message.Create New Patient") }}</h6>
          </n-button>
        </div>
      </card>

      <!-- Patient Details-->
      <card id="patient-details-section" v-if="patient.firstName || IS_NEW_PATIENT">
        <div slot="header">
          <div class="row">
            <div class="col-12">
              <h4 slot="header" class="card-title">
                {{ $t("message.Enter Appointment Details") }}
              </h4>
            </div>
          </div>
          <!--           <div class="row">
            <div class="col-8">
              <h4 slot="header" class="card-title">
                {{ $t("message.Patient Details") }}
              </h4>
            </div>
            <div class="col-4 text-right pt-2">
              <i class="fa fa-times-circle fa-2x text-muted" style="font-weight: 100" @click="resetPatientSelection()"></i>
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row mt-1">
              <div class="col-lg-12 pb-3 mt-2">
                <fg-input class="form-control-lg" :disabled="PATIENT_DETAILS_ENTERED" name="reason" :placeholder="$t('message.Reason for consultation')" v-model="reason" v-validate="modelValidations.reason" :error="getError('reason')" addon-left-icon="now-ui-icons travel_info"></fg-input>
              </div>
            </div>
          </div>
        </div>

        <!-- If hospital not enabled-->
        <!--         <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12" v-if="
                  settings.directTelemedicine.hospitalId.enabled &&
                  !settings.directTelemedicine.hospitalId.required
                ">
                <n-checkbox v-model="IS_REGISTERED_PATIENT">
                  <h6 style="line-height: 27px">
                    {{ $t("message.I know my Patient/Registration ID") }}
                  </h6>
                </n-checkbox>
              </div>

              <div class="col-12" v-if="
                  (settings.directTelemedicine.hospitalId.enabled &&
                    !settings.directTelemedicine.hospitalId.required &&
                    !IS_REGISTERED_PATIENT) ||
                  !settings.directTelemedicine.hospitalId.enabled
                ">
                <div class="row">
                  <div class="col-lg-6 pb-3 mt-2">
                    <fg-input class="form-control-lg" :disabled="PATIENT_DETAILS_ENTERED" name="firstName" :placeholder="$t('message.First Name')" v-model="patient.firstName" v-validate="modelValidations.firstName" :error="getError('firstName')" addon-left-icon="now-ui-icons users_circle-08"></fg-input>
                  </div>

                  <div class="col-lg-6">
                    <fg-input class="form-control-lg" :disabled="PATIENT_DETAILS_ENTERED" name="lastName" :placeholder="$t('message.Last Name')" v-model="patient.lastName" v-validate="modelValidations.lastName" :error="getError('lastName')" addon-left-icon="now-ui-icons text_caps-small"></fg-input>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-lg-6 pb-3">
                    <fg-input :class="PATIENT_DETAILS_ENTERED?'disabled':''" class="form-control-lg" name="gender" v-model="patient.gender" v-validate="modelValidations.gender" :error="getError('gender')">
                      <el-select class="select-primary" :placeholder="$t('message.Gender')" v-model="patient.gender" :class="!patient.gender ? 'placeholder' : ''" :disabled="PATIENT_DETAILS_ENTERED">
                        <el-option v-for="option in [
                            { name: 'Male', value: 'male' },
                            { name: 'Female', value: 'female' },
                            { name: 'Other', value: 'trans' },
                          ]" class="select-danger" :value="option.value" :label="option.name" :key="option.name"></el-option>
                      </el-select>
                    </fg-input>
                  </div>

                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-6">
                        <fg-input id="years" class="form-control-lg" name="ageYears" type="number" v-model="patientAgeYears" v-validate="modelValidations.ageYears" :placeholder="$t('message.Age')" :error="getError('ageYears')" :disabled="PATIENT_DETAILS_ENTERED">
                        </fg-input>
                        <n-button type="neutral" style="
                            position: absolute;
                            top: -5px;
                            inset-inline-end: 27px;
                            color: #b5b5b5;
                            border-left: 1px solid;
                          " @click.native="openyears">Years</n-button>
                      </div>
                      <div class="col-6">
                        <fg-input class="form-control-lg" id="months" name="ageMonths" type="number" v-model="patientAgeMonths" v-validate="modelValidations.ageMonths" :placeholder="$t('message.Age')" :error="getError('ageMonths')" :disabled="PATIENT_DETAILS_ENTERED"></fg-input>
                        <n-button type="neutral" style="
                            position: absolute;
                            top: -5px;
                            inset-inline-end: 27px;
                            color: #b5b5b5;
                            border-left: 1px solid;
                            padding: 1em;
                          " @click.native="openmonths">Months</n-button>
                      </div>
                      <div class="col-12">
                        <fg-input class="hide-input" name="age" v-model="patient.dob" v-validate="modelValidations.age" :error="getError('age')"></fg-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12">
                    <h4 slot="header" class="card-title" style="font-weight: 500; text-transform: none">
                      {{ $t("message.Enter Appointment Details") }}
                    </h4>
                  </div>
                  <div class="col-lg-12 pb-3 mt-2">
                    <fg-input class="form-control-lg" :disabled="PATIENT_DETAILS_ENTERED" name="reason" :placeholder="$t('message.Reason for consultation')" v-model="reason" v-validate="modelValidations.reason" :error="getError('reason')" addon-left-icon="now-ui-icons travel_info"></fg-input>
                  </div>
                </div>
              </div>

              <div class="col-12" v-if="
                  (settings.directTelemedicine.hospitalId.enabled &&
                    settings.directTelemedicine.hospitalId.required) ||
                  IS_REGISTERED_PATIENT
                ">
                <fg-input class="form-control-lg" :disabled="PATIENT_DETAILS_ENTERED" name="patient-id" :placeholder="$t('message.Type Patient/EMR ID and click submit')" v-model="patientSearchQuery" addon-left-icon="now-ui-icons users_circle-08"></fg-input>
                <n-button type="primary" round @click.native="searchPatient()" style="position: absolute; inset-inline-end: 22px; top: -4px" v-if="patientSearchQuery" :disabled="PATIENT_DETAILS_ENTERED">
                  <h6 class="m-0">{{ $t("message.Submit") }}</h6>
                </n-button>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row mt-5" v-if="!PATIENT_DETAILS_ENTERED">
          <div class="col-12 text-center">
            <!-- If payment is enabled -->
            <n-button type="primary" round @click.native="goToPayment()" v-if="
                settings.billingEnabled &&
                doctor.billingDetails.enabled">
              <h6 class="m-0">{{ $t("message.Next") }}</h6>
            </n-button>

            <!-- If payment is disabled -->
            <n-button type="primary" round @click.native="bookAppointment()" v-else>
              <h6 class="m-0">{{ $t("message.Book Now") }}</h6>
            </n-button>
          </div>
        </div>
      </card>

      <!-- Payment -->
      <card id="payment-section" class="card-contributions" v-if="PATIENT_DETAILS_ENTERED">
        <h4 slot="header" class="card-title">
          {{ $t("message.Payment") }}
        </h4>

        <div class="mb-2 mb-5 text-center" style="font-size: x-large">
          <div style="
              color: grey;
              border-radius: 10%;
              text-decoration: line-through;
            " v-if="appointment && appointment.billingDetails.actualAmount" class="pl-2">
            <i :class="getCurrencyClass(appointment.billingDetails.currency)"></i>
            <span>{{ appointment.billingDetails.actualAmount }}</span>
          </div>

          <div style="color: grey; border-radius: 10%" v-if="appointment && appointment.billingDetails.amount" class="pl-2 text-primary">
            <i :class="getCurrencyClass(appointment.billingDetails.currency)"></i>
            <span>{{ appointment.billingDetails.amount }}</span>
          </div>
          <h3 class="card-category">{{ $t("message.Consultation charges") }}</h3>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 offset-md-3">
            <fg-input class="form-control-lg" name="coupon-code" :placeholder="$t('message.Coupon Code')" v-model="couponCode" onkeyup="this.value = this.value.toUpperCase();" @click.native="IS_COUPON_CODE_ERR = null" :disabled="COUPON_CODE_APPLIED"></fg-input>
            <n-button type="primary" round style="position: absolute; top: -9px; inset-inline-end: 15px; height: 46px" @click.native="applyCoupon()" v-if="this.couponCode && !COUPON_CODE_APPLIED">
              <h6 class="m-0">{{ $t("message.Apply") }}</h6>
            </n-button>
            <n-button type="danger" round style="position: absolute; top: -9px; inset-inline-end: 15px; height: 46px" v-if="COUPON_CODE_APPLIED" @click.native="removeCoupon()">
              <h6 class="m-0">{{ $t("message.Remove") }}</h6>
            </n-button>
          </div>
          <div class="col-12 col-md-6 offset-md-3">
            <span class="text-danger pt-1" v-if="IS_COUPON_CODE_ERR">{{
              $t("message.Oops! Coupon could not be applied")
            }}</span>

            <span class="text-success pt-1" v-if="COUPON_CODE_APPLIED">
              {{ $t("message.Coupon applied successfully You saved") }}
              <i :class="getCurrencyClass(appointment.billingDetails.currency)"></i>
              {{
                appointment.billingDetails.actualAmount -
                appointment.billingDetails.amount
              }}
            </span>
          </div>
        </div>

        <div class="row" slot="footer" v-if="appointment.billingDetails.amount != 0">
          <div class="col-12 col-lg-12" v-if="settings">
            <div class="card-stats justify-content-center">
              <n-button type="primary" @click.native="initiatePayment()" round>
                <h5 style="
                    margin: 0px;
                    margin-left: 15px;
                    margin-right: 15px;
                    font-weight: 600;
                  ">
                  PAY
                </h5>
              </n-button>
            </div>
          </div>
        </div>

        <div class="row" slot="footer" v-if="appointment.billingDetails.amount == 0">
          <div class="col-12 text-center">
            <n-button type="primary" round @click="confirmAppointment()">
              <h6 class="m-0">{{ $t("message.Book Now") }}</h6>
            </n-button>
          </div>
        </div>
      </card>
    </div>

    <!-- <otp-modal :identifier="patient" ref="otpModal" @otp-success="onOtpSuccess"></otp-modal> -->

    <form id="isalucroForm" name="isalucroForm" :action="SALUCRO_PAYMENT_URL" method="post" v-if="settings">
      <input type="hidden" name="token" id="input-token" :value="SALUCRO_TOKEN" />
      <input type="hidden" name="mid" id="input-mid" :value="SALUCRO_MID" />
      <input type="hidden" name="check_sum_hash" id="input-hash" :value="SALUCRO_HASH" />
    </form>
  </div>
</template>

<script>
import { Modal, Tabs, TabPane, Checkbox } from "src/components";
import { Select, Option, DatePicker, TimeSelect } from "element-ui";

import OtpInput from "@bachdgvn/vue-otp-input";
import moment from "moment";
import { Validator } from "vee-validate";
const dictionary = {
  custom: {
    mobileNumber: {
      required: "Mobile number is required",
    },
    firstName: {
      required: "First name is required",
    },
    lastName: {
      required: "Last name is required",
    },
    gender: {
      required: "Gender is required",
    },
    age: {
      required: "Age is required",
    },
    reason: {
      required: "Reason is required",
    },
  },
};

Validator.localize("en", dictionary);
import socket from "@/services/socket";
// import KhaltiCheckout from "khalti-checkout-web";
// const { v4: uuid } = require("uuid");
// const sha256 = require("js-sha256").sha256;
// const Base64 = require("js-base64").Base64;

export default {
  name: "confirm-booking",

  components: {
    Modal,
    "v-otp-input": OtpInput,
    Tabs,
    TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Checkbox.name]: Checkbox,
  },

  data() {
    return {
      patient: {
        firstName: null,
        lastName: null,
        gender: null,
        dob: null,
        mobileNumber: null,
        email: null,
      },
      patientSearchQuery: null,
      /* settings: null, */
      OTP_VALIDATED: false,
      PAYMENT_INPROGRESS: false,
      PATIENT_DETAILS_ENTERED: false,
      IS_REGISTERED_PATIENT: false,
      GOT_PATIENT_FROM_SERVER: false,
      IS_NEW_PATIENT: false,
      appointment: null,
      reason: null,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
      preferredCountries: ["IN"],
      selectedMobileNumber: "",
      defaultCountry: "IN",
      isValidMobile: false,
      borderRadius: 25,
      patientAgeYears: null,
      patientAgeMonths: null,
      associatedPatients: [],
      couponCode: null,
      IS_COUPON_CODE_ERR: false,
      COUPON_CODE_APPLIED: false,

      SALUCRO_TOKEN: "",
      SALUCRO_HASH: "",
      SALUCRO_MID: "",
      SALUCRO_PAYMENT_URL: "",
      loader: null,
    };
  },

  computed: {
    modelValidations() {
      return {
        firstName: {
          required: true,
        },
        lastName: {
          required: true,
        },
        email: {
          email: true,
        },
        mobileNumber: {
          required: true,
        },
        gender: {
          required: true,
        },
        age: {
          required: true,
        },
        ageYears: {
          min_value: 0,
          max_value: 120,
          integer: true,
        },
        ageMonths: {
          min_value: 0,
          max_value: 11,
          integer: true,
        },
        reason: {
          required: true,
        },
      };
    },
    doctor() {
      return this.$store.state.selectedDoctor;
    },
    selectedLocation() {
      return this.$store.state.selectedLocation;
    },
    appointmentDate() {
      let slot = this.$store.state.selectedSlot;
      return moment(slot.start).format("Do MMMM YYYY");
    },
    appointmentTime() {
      let slot = this.$store.state.selectedSlot;
      return moment(slot.start).format("h:mm A");
    },
    SHOW_OTP_MODAL() {
      return this.$store.state.SHOW_OTP_MODAL;
    },
    slotType() {
      return this.$store.state.slotType;
    },
    settings() {
      return this.$store.state.settings;
    },
  },

  watch: {
    "patient.gender": function () {
      setTimeout(() => {
        this.$validator.validate("gender");
      }, 500);
    },
    patientAgeYears: function () {
      this.calculateDob();
    },
    patientAgeMonths: function () {
      this.calculateDob();
    },
  },

  async mounted() {
    if (!this.doctor) {
      this.$router.back();
    } else {
      console.log(this.settings);
      console.log(this.doctor);
      this.selectPatient(this.user);
      /*       try {
        if (this.user.mobileNumber) {
          this.associatedPatients = await this.$store.dispatch(
            "searchPatient",
            {
              query: this.user.mobileNumber,
            }
          );
        }

        //If no assosiated patients, show creation form
        if (this.associatedPatients.length < 1) {
          this.IS_NEW_PATIENT = true;
        }
      } catch (e) {
        console.log(e);
      } */
    }
  },

  methods: {
    openyears() {
      document.getElementById("years").focus();
    },
    openmonths() {
      document.getElementById("months").focus();
    },
    //Form
    mobileNumberUpdate(payload) {
      (this.patient.mobileNumber = payload.formattedNumber),
        (this.isValidMobile = payload.isValid);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    getOtp() {
      let that = this;
      this.$validator.validateAll().then(async (valid) => {
        if (valid && that.isValidMobile) {
          console.log("confirmbooking patient - ", that.patient);
          that.$refs.otpModal.getOtp();
        }
      });
    },
    getAge(dob) {
      var m = moment(dob);
      var years = moment().diff(m, "years", false);
      var months = moment().diff(m.add(years, "years"), "months", false);
      return years + " years, " + months + " months";
    },
    calculateDob() {
      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.patient.dob = monthOfBirth + "/01/" + yearOFBirth;
    },
    async searchPatient() {
      if (this.patientSearchQuery) {
        try {
          let patients = await this.$store.dispatch("searchPatient", {
            patient: this.patient,
            query: this.patientSearchQuery,
          });

          this.GOT_PATIENT_FROM_SERVER = true;

          let patient = patients[0];
          this.patient.patientId = patient.patientId;
          (this.patient.firstName = patient.firstName),
            (this.patient.lastName = patient.lastName),
            (this.patient.gender = patient.gender),
            (this.patient.dob = patient.dob),
            (this.patient.phoneNumber = patient.mobileNumber);

          if (patient.email) {
            this.patient.email = patient.email;
          }
        } catch (e) {
          console.log(e);

          swal.fire({
            type: "info",
            title: this.$t(
              "message.Patient details not found for given Patient/EMR ID"
            ),
            text: this.$t("message.Kindly verify the ID and try again"),
            timer: 3000,
          });
        }
      }
    },
    selectPatient(patient) {
      this.patient.firstName = patient.firstName;
      this.patient.lastName = patient.lastName;
      this.patient.gender = patient.gender;
      this.patient.dob = patient.dob;
      this.patient.patientId = patient.patientId;

      if (!this.patient.email && patient.email) {
        this.patient.email = patient.email;
      }

      if (patient.mobileNumber) {
        this.patient["mobileNumber"] = patient.mobileNumber;
      }

      var m = moment(this.patient.dob);
      var years = moment().diff(m, "years", false);
      this.patientAgeYears = years;

      m = moment(m).add(years, "years");

      var months = moment().diff(m, "months", false);
      this.patientAgeMonths = months;

      setTimeout(() => {
        document
          .getElementById("patient-details-section")
          .scrollIntoViewIfNeeded();
      }, 500);
    },
    createNewAccount() {
      this.IS_NEW_PATIENT = true;
      setTimeout(() => {
        document
          .getElementById("patient-details-section")
          .scrollIntoViewIfNeeded();
      }, 500);
    },
    resetPatientSelection() {
      this.patient.firstName = null;
      this.patient.lastName = null;
      this.patient.gender = null;
      this.patient.dob = null;
      this.patientAgeYears = null;
      this.patientAgeMonths = null;

      if (this.associatedPatients.length > 0) {
        this.IS_NEW_PATIENT = false;
      }
    },

    async onOtpSuccess() {
      this.settings = await this.$store.dispatch("getSettings", {
        patient: this.patient,
      });

      this.$store.commit("setState", {
        stateName: "settings",
        stateValue: this.settings,
      });

      this.OTP_VALIDATED = true;
      this.$store.commit("setState", {
        stateName: "SHOW_OTP_MODAL",
        stateValue: false,
      });

      swal
        .fire({
          type: "success",
          title: this.$t("message.OTP validated successfully"),
          text: this.$t("message.Kindly enter patient details"),
          timer: 3000,
        })
        .then(async () => {
          try {
            this.associatedPatients = await this.$store.dispatch(
              "searchPatient",
              {
                patient: this.patient,
                query: this.patient.mobileNumber,
              }
            );

            //If no assosiated patients, show creation form
            if (this.associatedPatients.length < 1) {
              this.IS_NEW_PATIENT = true;
            }
          } catch (e) {
            console.log(e);
          }
        });
    },
    handleOnChange(value) {},
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },

    //Payment
    async applyCoupon() {
      try {
        if (this.couponCode) {
          this.appointment = await this.$store.dispatch("applyCoupon", {
            mobileNumber: this.patient.mobileNumber,
            couponCode: this.couponCode,
            appointmentId: this.appointment._id,
          });

          this.COUPON_CODE_APPLIED = true;
          this.IS_COUPON_CODE_ERR = false;
        }
      } catch (e) {
        console.log(e);
        this.IS_COUPON_CODE_ERR = true;
      }
    },
    async removeCoupon() {
      try {
        this.appointment = await this.$store.dispatch("removeCoupon", {
          mobileNumber: this.patient.mobileNumber,
          couponCode: this.couponCode,
          appointmentId: this.appointment._id,
        });

        this.couponCode = null;
        this.COUPON_CODE_APPLIED = false;
      } catch (e) {
        console.log(e);
      }
    },
    async goToPayment() {
      try {
        let valid = await this.$validator.validateAll();
        if (valid /* && this.isValidMobile */) {
          this.appointment = await this.$store.dispatch("blockAppointment", {
            patient: this.patient,
            reason: this.reason,
            createdBy: "patient",
            consultationType:
              this.slotType == "InPerson" ? "inperson" : "telemedicine",
            SAVE_PATIENT: this.IS_NEW_PATIENT,
          });

          this.PATIENT_DETAILS_ENTERED = true;

          if (this.appointment.billingDetails.amount) {
            setTimeout(() => {
              document
                .getElementById("payment-section")
                .scrollIntoViewIfNeeded();
            }, 500);
          }
        }
      } catch (e) {
        if (
          e &&
          e.response &&
          e.response.data &&
          e.response.data.code &&
          e.response.data.code.indexOf("ALREADY") > -1
        ) {
          swal
            .fire({
              type: "error",
              title: this.$t("message.Oops!"),
              text: this.$t(
                "message.Appointment slot already booked Kindly select another slot"
              ),
            })
            .then(() => {
              this.$router.push("/slots/" + this.doctor._id);
            });
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Could not create the appointment"),
            timer: 5000,
          });
        }
      }
    },
    initiatePayment() {
      if (this.settings.paymentSettings.razorpay.enabled) {
        this.initiateRazorPayPayment();
      } else if (this.settings.paymentSettings.khalti.enabled) {
        this.initiateKhaltiPayment();
      } else if (this.settings.paymentSettings.salucro.enabled) {
        this.initiateSalucroPayment();
      } else {
        swal.fire("No payment method available");
      }
    },
    async initiateRazorPayPayment() {
      let that = this;
      let loader = that.$loading.show();
      this.PAYMENT_INPROGRESS = true;
      let transaction = await this.$store.dispatch("initiatePayment", {
        gateway: "razorpay",
        appointmentId: this.appointment._id,
        patient: this.patient,
      });
      loader.hide();

      var options = {
        key: this.settings.paymentSettings.razorpay.key_id,
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
        currency: transaction.paymentDetails.currency,
        name: this.settings.paymentSettings.razorpay.name,
        description: this.settings.paymentSettings.razorpay.paymentDescription,
        order_id: transaction.paymentDetails.orderId,
        prefill: {
          name: this.patient.firstName + " " + this.patient.lastName,
          email:
            this.patient.email ||
            this.settings.directBookings.defaultEmail ||
            "",
          contact: this.patient.mobileNumber,
        },
        theme: {
          color:
            document.documentElement.style.getPropertyValue(
              "--color-primary"
            ) || "#f96332",
        },
      };

      if (this.settings.paymentSettings.razorpay.logoUrl) {
        options.image = this.settings.paymentSettings.razorpay.logoUrl;
      }

      //var rzp1 = new Razorpay(options);
      //this.PAYMENT_INPROGRESS = false;
      //rzp1.open();
      window.razorpaySuccessCallback = async function (response) {
        response.appointmentId = that.appointment._id;
        let verificationResponse = await that.$store.dispatch("verifyPayment", {
          gateway: "razorpay",
          transaction: response,
          patient: that.appointment.patient,
        });

        if (
          verificationResponse &&
          verificationResponse.latestStatus == "Success"
        ) {
          that.PAYMENT_INPROGRESS = false;
          that.confirmAppointment();
        } else {
          that.PAYMENT_INPROGRESS = false;
          swal.fire({
            type: "error",
            title: that.$t("message.Payment unsuccessful"),
            text: that.$t(
              "message.Kindly retry If any amount deducted from your account will be refunded within 5 working days"
            ),
            showConfirmButton: true,
            confirmButtonText: that.$t("message.Retry"),
            showCancelButton: true,
            cancelButtonText: that.$t("message.Exit"),
            allowOutsideClick: false,
          });
        }
      };

      window.razorpayCancelCallback = function (error) {
        console.log(error);
        that.PAYMENT_INPROGRESS = false;
        swal.fire({
          type: "error",
          title: that.$t("message.Payment failed!"),
          text: that.$t(
            "message.Any consultation fees paid will be refunded within 7 working days"
          ),
          timer: 5000,
        });
      };

      RazorpayCheckout.on("payment.success", window.razorpaySuccessCallback);
      RazorpayCheckout.on("payment.cancel", window.razorpaySuccessCallback);
      RazorpayCheckout.open(options);
    },
    async initiateKhaltiPayment() {
      let that = this;
      let loader = this.$loading.show();
      this.PAYMENT_INPROGRESS = true;

      let transaction = await this.$store.dispatch("initiatePayment", {
        gateway: "khalti",
        appointmentId: this.appointment._id,
        patient: this.patient,
      });
      loader.hide();

      let config = {
        // replace this key with yours
        publicKey: that.settings.paymentSettings.khalti.publicKey,
        productIdentity: that.appointment._id,
        productName: "Appointment",
        productUrl: window.location.href,
        eventHandler: {
          async onSuccess(response) {
            console.log(response);
            response.appointmentId = that.appointment._id;
            response.transactionId = transaction._id;
            let verificationResponse = await that.$store.dispatch(
              "verifyPayment",
              {
                gateway: "khalti",
                transaction: response,
                patient: that.appointment.patient,
              }
            );

            if (
              verificationResponse &&
              verificationResponse.latestStatus == "Success"
            ) {
              that.confirmAppointment();
            } else {
              that.PAYMENT_INPROGRESS = false;
              swal.fire({
                type: "error",
                title: that.$t("message.Payment unsuccessful"),
                text: that.$t(
                  "message.Kindly retry If any amount deducted from your account will be refunded within 5 working days"
                ),
                showConfirmButton: true,
                confirmButtonText: that.$t("message.Retry"),
                showCancelButton: true,
                cancelButtonText: that.$t("message.Exit"),
                allowOutsideClick: false,
              });
            }
          },
          // onError handler is optional
          onError(error) {
            // handle errors
            that.PAYMENT_INPROGRESS = false;
            swal.fire("Payment error");
            console.log(error);
          },
          onClose() {
            that.PAYMENT_INPROGRESS = false;
          },
        },
        paymentPreference: [
          "KHALTI",
          "EBANKING",
          "MOBILE_BANKING",
          "CONNECT_IPS",
          "SCT",
        ],
      };

      // let khaltiCheckout = new KhaltiCheckout(config);
      khaltiCheckout.show({
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
      });
    },
    async initiateSalucroPayment() {
      let loader = null;
      try {
        let that = this;
        loader = that.$loading.show();

        let transaction = await this.$store.dispatch("initiatePayment", {
          gateway: "salucro",
          appointmentId: this.appointment._id,
          patient: this.patient,
        });

        let response = await this.$store.dispatch("generateSalucroToken", {
          appointment: this.appointment,
        });

        this.SALUCRO_PAYMENT_URL = response.paymentUrl;
        this.SALUCRO_TOKEN = response.token;
        this.SALUCRO_HASH = response.hash;
        this.SALUCRO_MID = response.mid;

        await setTimeout(null, 2000);

        loader.hide();

        document.forms["isalucroForm"].submit();
      } catch (e) {
        console.log(e);
        loader.hide();
        swal.fire({
          type: "info",
          title: "Payment initiation failed!",
          text: "Kindly contact the coordinator",
          timer: 5000,
        });
      }
    },

    //Appointment
    async confirmAppointment() {
      this.loader = this.$loading.show();
      let that = this;
      let appointment = await that.$store.dispatch("confirmAppointment", {
        appointmentId: that.appointment._id,
        patient: that.appointment.patient,
      });

      that.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });

      that.PAYMENT_INPROGRESS = false;

      if (appointment && appointment._id) {
        socket.connect(appointment._id);
        socket.emit("appointmentListUpdate", {
          providerId: appointment.provider.providerId,
        });
        this.loader.hide();
        /*if (
          this.settings &&
          this.settings.directBookings &&
          this.settings.directBookings.GENERATE_RECEIPT
        ) {
          let loader = this.$loading.show();
          try {
            appointment.provider.user = this.doctor;
            await ReceiptService.getDataURL(appointment, async (dataUrl) => {
              try {
                await this.$store.dispatch("emailReceipt", {
                  patient: appointment.patient,
                  data: {
                    to: appointment.patient.email,
                    appointmentReferenceId: appointment.referenceId,
                    providerFirstName: appointment.provider.firstName,
                    providerLastName: appointment.provider.lastName,
                    appointmentDateTime: moment(
                      parseInt(appointment.scheduledTimestamp.start)
                    ).format("Do MMMM YYYY h:mm A"),
                    receipt: dataUrl,
                  },
                });
              } catch (e) {
                console.log(e);
              }
            });
          } catch (e) {
            console.log(e);
          }
          loader.hide();
        }*/

        swal.fire({
          type: "success",
          title: this.$t("message.Booking Confirmed"),
          timer: 5000,
        });
        await that.$store.commit("setState", {
          stateName: "homePageActiveTab",
          stateValue: "appointments",
        });
        that.$router.push("patienthome");
      } else {
        that.loader.hide();
        swal.fire({
          type: "error",
          title: that.$t("message.Booking Failed"),
          text: that.$t(
            "message.We are sorry There was problem with your booking"
          ),
        });
      }
    },
    async bookAppointment() {
      try {
        let valid = await this.$validator.validateAll();
        if (valid /* && this.isValidMobile */) {
          this.loader = this.$loading.show();
          this.appointment = await this.$store.dispatch("blockAppointment", {
            patient: this.patient,
            reason: this.reason,
            createdBy: "patient",
            consultationType:
              this.slotType == "InPerson" ? "inperson" : "telemedicine",
            SAVE_PATIENT: this.IS_NEW_PATIENT,
          });
          this.loader.hide();
          this.confirmAppointment();
        }
      } catch (e) {
        this.loader.hide();
        if (
          e &&
          e.response &&
          e.response.data &&
          e.response.data.code &&
          e.response.data.code.indexOf("ALREADY") > -1
        ) {
          swal
            .fire({
              type: "error",
              title: this.$t("message.Oops!"),
              text: this.$t(
                "message.Appointment slot already booked Kindly select another slot"
              ),
            })
            .then(() => {
              this.$router.push("/slots/" + this.doctor._id);
            });
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Could not create the appointment"),
            timer: 5000,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
/deep/ .otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
/deep/ .otp-input .error {
  border: 1px solid red !important;
}
/deep/ .otp-input::-webkit-inner-spin-button,
/deep/ .otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/deep/ .otp-number-input {
  width: 40px;
}

/deep/ .modal.modal-mini .modal-dialog {
  max-width: 430px;
}
/deep/ .modal.fade.modal-primary.show.d-block.modal-mini {
  pointer-events: none;
}

#payment-section .col-md-4 {
  max-width: 16.66667%;
}

/deep/ .card-contributions .card-title {
  padding-top: 0px;
}

/deep/ .el-select.select-primary {
  width: 100%;
}
/deep/ input.el-input__inner {
  height: 100%;
}
/deep/ .el-loading-mask {
  background: #fffc !important;
  top: -15px;
}
/deep/
  .el-select.select-primary.placeholder
  input.el-input__inner::placeholder {
  color: #bbbbbb;
}

/deep/ .input-group > .form-control:focus {
  z-index: 0;
}

/deep/.disabled input {
  background-color: #e3e3e3 !important;
}

@media screen and (max-width: 375px) {
  /deep/ input.otp-input {
    margin: 0px;
  }
}
</style>
